<template>
  <bk-bets-list :data-func="getBets" :show-user="true" />
</template>
<script>
  import bkService from '../../../../services/bk.service'

  import bkBetsList from '../../../common/bk-bets-list.vue'

  export default {
    name: 'client-bk-bets',
    components: { bkBetsList },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    methods: {
      async getBets(filter) {
        filter.clientId = this.clientId;
        return await bkService.get(filter);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/bets/bk-bets.vue